// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-content {
   background-color:  #ddeeed;
   padding: 20px;   
  }


  
  .how-to-video, .instruction-summary, .case-studies, .please-note {
    margin-bottom: 40px;
    padding: 10px;  
  }

  .instruction-summary h3 {
    background-color: #007bff;
    color: white;
    cursor: pointer;
    padding: 10px;
    margin-top: 10px;
    border-radius: 5px;
  }
  
  .collapsible-content {
    padding: 15px;
    border: 1px solid #007bff;
    border-top: none;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  
  .cta-button {
    background-color: #4bf;
    color: #ffffff;
    padding: 8px 25px;
    border-radius: 25px;
    text-decoration: none;
    display: inline-block;
    transition: background-color 0.3s ease;
  }
  
  .cta-button:hover {
    background-color: #0056b3;
  }
  
  
  .video-tutorial {
    /* max-width: 100%; */
    height: 250px;
  }

  .video-tutorial {
    height : (2850 - 800)


  

  }

  .custom-gray-divider {
    width: 1px; /* Width of the line */
    height: 80px; /* Height of the line */
    padding: 1px;
    background-color: rgb(209, 203, 203);; /* Color of the line, gray in this example */
    margin: 0 auto; /* Centers the line horizontally if within a block container */
}
.custom-list ul {
  list-style-type: none; /* Removes default list style */
  padding-left: 0; /* Removes default padding */
  list-style: none;
}

.custom-list li {
  position: relative;
  padding-left: 20px; /* Adjust space for the + sign */
  /* list-style: none; */
  padding: 10px;
}

.custom-list li::before {
  /* Adds '+' before each list item */
    color: black; /* Sets the color of the '+' */
    font-weight: bold; /* Makes the '+' bold */
    display: inline-block; /* Ensures it behaves like a text character */
    width: 20px; /* Provides a fixed width for alignment */
  padding: 1px;

}

.cardBox {
  /* border: 1px solid #ccc; */
  border-radius: 5px;
  padding: 15px;
  margin: 10px;
  box-shadow: 0 1px 8px 0 rgba(145, 129, 129, 0.2);
  transition: 0.3s;
}

.cardBox:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

@media screen and (max-width: 1458px) {
  
  .how-to-video, .instruction-summary, .case-studies, .please-note {
    margin-bottom: 20px;
    padding: 5px;
  }
  
  .instruction-summary h3 {
    padding: 5px;
    margin-top: 5px;
  }
  
  .collapsible-content {
    padding: 10px;
  }
  
  .cta-button {
    padding: 5px 15px;
  }
  .cardBox {
    /* border: 1px solid #ccc; */
    border-radius: 5px;
    padding: 15px;
    margin: 5px;
    box-shadow: 0 1px 8px 0 rgba(131, 116, 116, 0.2);
    transition: 0.3s;
  }
  
  .cardBox:hover {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
  }
  iframe {
    height: 150px;
  }
    
}

`, "",{"version":3,"sources":["webpack://./src/pages/howToUseSM/MainContent.css"],"names":[],"mappings":"AAAA;GACG,0BAA0B;GAC1B,aAAa;EACd;;;;EAIA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE;;;;;EAKF;;EAEA;IACE,UAAU,EAAE,sBAAsB;IAClC,YAAY,EAAE,uBAAuB;IACrC,YAAY;IACZ,oCAAoC,GAAG,4CAA4C;IACnF,cAAc,EAAE,8DAA8D;AAClF;AACA;EACE,qBAAqB,EAAE,+BAA+B;EACtD,eAAe,EAAE,4BAA4B;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB,EAAE,gCAAgC;EACpD,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,mCAAmC;IACjC,YAAY,EAAE,8BAA8B;IAC5C,iBAAiB,EAAE,uBAAuB;IAC1C,qBAAqB,EAAE,6CAA6C;IACpE,WAAW,EAAE,yCAAyC;EACxD,YAAY;;AAEd;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gDAAgD;IAChD,gBAAgB;EAClB;;EAEA;IACE,wCAAwC;EAC1C;EACA;IACE,aAAa;EACf;;AAEF","sourcesContent":[".main-content {\r\n   background-color:  #ddeeed;\r\n   padding: 20px;   \r\n  }\r\n\r\n\r\n  \r\n  .how-to-video, .instruction-summary, .case-studies, .please-note {\r\n    margin-bottom: 40px;\r\n    padding: 10px;  \r\n  }\r\n\r\n  .instruction-summary h3 {\r\n    background-color: #007bff;\r\n    color: white;\r\n    cursor: pointer;\r\n    padding: 10px;\r\n    margin-top: 10px;\r\n    border-radius: 5px;\r\n  }\r\n  \r\n  .collapsible-content {\r\n    padding: 15px;\r\n    border: 1px solid #007bff;\r\n    border-top: none;\r\n    max-height: 0;\r\n    overflow: hidden;\r\n    transition: max-height 0.3s ease-out;\r\n    border-bottom-left-radius: 5px;\r\n    border-bottom-right-radius: 5px;\r\n  }\r\n  \r\n  .cta-button {\r\n    background-color: #4bf;\r\n    color: #ffffff;\r\n    padding: 8px 25px;\r\n    border-radius: 25px;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .cta-button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  \r\n  .video-tutorial {\r\n    /* max-width: 100%; */\r\n    height: 250px;\r\n  }\r\n\r\n  .video-tutorial {\r\n    height : (2850 - 800)\r\n\r\n\r\n  \r\n\r\n  }\r\n\r\n  .custom-gray-divider {\r\n    width: 1px; /* Width of the line */\r\n    height: 80px; /* Height of the line */\r\n    padding: 1px;\r\n    background-color: rgb(209, 203, 203);; /* Color of the line, gray in this example */\r\n    margin: 0 auto; /* Centers the line horizontally if within a block container */\r\n}\r\n.custom-list ul {\r\n  list-style-type: none; /* Removes default list style */\r\n  padding-left: 0; /* Removes default padding */\r\n  list-style: none;\r\n}\r\n\r\n.custom-list li {\r\n  position: relative;\r\n  padding-left: 20px; /* Adjust space for the + sign */\r\n  /* list-style: none; */\r\n  padding: 10px;\r\n}\r\n\r\n.custom-list li::before {\r\n  /* Adds '+' before each list item */\r\n    color: black; /* Sets the color of the '+' */\r\n    font-weight: bold; /* Makes the '+' bold */\r\n    display: inline-block; /* Ensures it behaves like a text character */\r\n    width: 20px; /* Provides a fixed width for alignment */\r\n  padding: 1px;\r\n\r\n}\r\n\r\n.cardBox {\r\n  /* border: 1px solid #ccc; */\r\n  border-radius: 5px;\r\n  padding: 15px;\r\n  margin: 10px;\r\n  box-shadow: 0 1px 8px 0 rgba(145, 129, 129, 0.2);\r\n  transition: 0.3s;\r\n}\r\n\r\n.cardBox:hover {\r\n  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\r\n}\r\n\r\n@media screen and (max-width: 1458px) {\r\n  \r\n  .how-to-video, .instruction-summary, .case-studies, .please-note {\r\n    margin-bottom: 20px;\r\n    padding: 5px;\r\n  }\r\n  \r\n  .instruction-summary h3 {\r\n    padding: 5px;\r\n    margin-top: 5px;\r\n  }\r\n  \r\n  .collapsible-content {\r\n    padding: 10px;\r\n  }\r\n  \r\n  .cta-button {\r\n    padding: 5px 15px;\r\n  }\r\n  .cardBox {\r\n    /* border: 1px solid #ccc; */\r\n    border-radius: 5px;\r\n    padding: 15px;\r\n    margin: 5px;\r\n    box-shadow: 0 1px 8px 0 rgba(131, 116, 116, 0.2);\r\n    transition: 0.3s;\r\n  }\r\n  \r\n  .cardBox:hover {\r\n    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);\r\n  }\r\n  iframe {\r\n    height: 150px;\r\n  }\r\n    \r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
